/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Donthaveanaccount3Inputs */

const en_donthaveanaccount3 = /** @type {(inputs: Donthaveanaccount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't have an account?`)
};

const de_donthaveanaccount3 = /** @type {(inputs: Donthaveanaccount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast noch kein Konto?`)
};

/**
* | output |
* | --- |
* | "Don't have an account?" |
*
* @param {Donthaveanaccount3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const donthaveanaccount3 = /** @type {((inputs?: Donthaveanaccount3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Donthaveanaccount3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_donthaveanaccount3(inputs)
	return de_donthaveanaccount3(inputs)
});
export { donthaveanaccount3 as "dontHaveAnAccount" }